import orienta from '../../assets/orienta_negative.png'
import style from './style.module.css'

export default function Header(){
    return (
        <header className="px-5 pt-5">
            <img className={style.logo + " "} src={orienta} alt="Orienta Covid" />
        </header>
    )
}